
<div
  class="lobby-table-game-specific-wrapper lobbyTableGameSpecificWrapper--3fAEk desktop--1Txr1"
  data-role="lobby-table-game-specific-wrapper"
>
  <div class="lobbyTableGameSpecificData--3whkv TableHistoryStatistic--3az41">
    <div class="itemsContainer--uoZQl" style="padding-bottom: 0%">
      <div
        class="itemsRow--2Nmj9 skipRowsTransition--QL5CX"
        style="
          width: 100%;
          padding-bottom: 8.45455%;
          padding-left: 0%;
          padding-right: 0%;
          left: 0%;
        "
      >
        <div
          v-for="(result, index) in results.slice(0, 8)"
          :key="index"
          class="itemContainer--1x-Md noTransition--1UEsy"
          :style="
            'width: 11.625%; padding-bottom: 8.45455%; transform: translateX(' +
            getTranslateX(index) +
            '%);'
          "
        >
          <div class="itemScale--3KxD1">
            <svg class="" viewBox="0 0 42 30" width="100%" height="100%" :data-sector="result">
              <linearGradient
                id="X2-pill"
                gradientUnits="userSpaceOnUse"
                x1="13.02"
                y1="-8.100000000000001"
                x2="30.66"
                y2="36.6"
              >
                <stop offset="0%" stop-color="#E6E7E8"></stop>
                <stop offset="100%" stop-color="#939598"></stop>
              </linearGradient>
              <linearGradient
                id="X7-pill"
                gradientUnits="userSpaceOnUse"
                x1="30.66"
                y1="36.6"
                x2="13.02"
                y2="-8.100000000000001"
              >
                <stop offset="0%" stop-color="#DBB251"></stop>
                <stop offset="28.89%" stop-color="#D6AA4B"></stop>
                <stop offset="48.73%" stop-color="#BE872F"></stop>
                <stop offset="68.43%" stop-color="#EBC963"></stop>
                <stop offset="100%" stop-color="#FFD67D"></stop>
              </linearGradient>
              <ellipse
                cx="21"
                cy="15"
                :rx="index == 0 ? '18.15' : '19.65'"
                :ry="index == 0 ? '12.15' : '13.65'"
                :fill="getCouleur(result)"
                :fill-opacity="index == 0 ? '0.8' : '0.15'"
                stroke="none"
              ></ellipse>
              <ellipse
                cx="21"
                cy="15"
                :rx="index == 0 ? '20.25' : '18.75'"
                :ry="index == 0 ? '14.25' : '12.75'"
                fill="none"
                :stroke-opacity="index == 0 ? '1' : '0.3'"
                :stroke="getCouleur(result)"
                stroke-width="1.5"
              ></ellipse>
              <text
                data="pill-value"
                dy="21.29"
                dx="21"
                text-anchor="middle"
                :style="
                  'font-size: 17px; fill: ' +
                  (index == 0 ? 'rgb(255, 255, 255)' : getCouleur(result)) +
                  '; font-family: Inter, Arial, sans-serif; font-weight: 500; opacity: 1;'
                "
              >
                {{ getAffichageResultat(result) }}
              </text>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
